import(/* webpackMode: "eager" */ "/foodcarttracker/app/global-error.tsx")